import {Component} from '@angular/core';

@Component({
  selector: 'sellions-iconic-message',
  templateUrl: 'sellions-iconic-message.html'
})
export class SellionsIconicMessageComponent {
  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/sellions-iconic-message/sellions-iconic-message.ts